/* Reviews carousel rows: auto-drifting, swipe/drag/trackpad scrollable, seamless loop.
   Runs after jala.js has rendered .review-row elements (both are deferred, in order). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IDLE_MS = 4000;

  function setupRow(row) {
    if (row.dataset.scroller) return;
    row.dataset.scroller = '1';
    var rev = row.classList.contains('review-row--rev');
    var speed = (rev ? -1 : 1) * 0.55; // px per frame (~33px/s at 60fps)
    var half = 0, pos = 0, hover = false, idleUntil = 0, dragging = false, sx = 0, sl = 0;

    function measure() { half = row.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);
    if (rev) { row.scrollLeft = half; }
    pos = row.scrollLeft;

    // A scroll event that lands where we put it is ours; anything else is the user.
    row.addEventListener('scroll', function () {
      if (Math.abs(row.scrollLeft - pos) > 1.5) { pos = row.scrollLeft; idleUntil = Date.now() + IDLE_MS; }
    }, { passive: true });

    function tick() {
      if (!half) measure();
      var canAuto = !reduce && !hover && !dragging && Date.now() > idleUntil && half > 0;
      if (canAuto) pos += speed;
      var wrapped = false;
      if (half > 0) {
        if (pos >= half) { pos -= half; sl -= half; wrapped = true; }
        else if (pos < 0) { pos += half; sl += half; wrapped = true; }
      }
      if (canAuto || wrapped) row.scrollLeft = pos;
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);

    if (window.matchMedia('(hover:hover)').matches) {
      row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
      row.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        e.preventDefault();
        dragging = true; sx = e.clientX; sl = row.scrollLeft; row.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        pos = sl - (e.clientX - sx); row.scrollLeft = pos;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false; row.classList.remove('is-dragging'); idleUntil = Date.now() + IDLE_MS;
      });
    }
    ['touchstart', 'touchend', 'wheel'].forEach(function (ev) {
      row.addEventListener(ev, function () { idleUntil = Date.now() + IDLE_MS; }, { passive: true });
    });
  }

  function setupAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.review-row'), setupRow);
  }
  setupAll();
  document.addEventListener('shopify:section:load', function (e) { setTimeout(function () { setupAll(e.target); }, 50); });
})();
